import React, { useState, useEffect } from "react";
import SuperAdminSidebar from "../SuperAdminSidebar";
import ManagerSidebar from "../ManagerSidebar";
import LeaderSidebar from "../LeaderSidebar";
import MemberSidebar from "../MemberSidebar";
import AdminNavbar from './AdminNavbar';
import AllInvoice from "./AllInvoice";
import NewInvoiceForm from "./NewInvoiceForm";
import EditInvoiceForm from "./EditInvoiceForm";
import axios from 'axios';
import './Invoice.css';

const Invoice = () => {
    const [activeTab, setActiveTab] = useState('All Invoices');
    const [editInvoiceId, setEditInvoiceId] = useState(null);
    const [showEditDrawer, setShowEditDrawer] = useState(false);
    const [drawerMounted, setDrawerMounted] = useState(false);
    const [drawerClosing, setDrawerClosing] = useState(false);
    const [statusCounts, setStatusCounts] = useState({
        Unpaid: 0, Paid: 0, PartiallyPaid: 0, Overdue: 0, Draft: 0
    });
    
    const userType = localStorage.getItem("usertype");
    const userFullName = (localStorage.getItem("fname") || "") + " " + (localStorage.getItem("lname") || "");

    useEffect(() => {
        fetchStatusCounts();
    }, [activeTab]);

    const fetchStatusCounts = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get('https://skcapi.btcjapan.co/get_invoices.php', {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.success && res.data.status_counts) {
                setStatusCounts(res.data.status_counts);
            }
        } catch (err) { console.error(err); }
    };

    const handleInvoiceCreated = () => { setActiveTab('All Invoices'); fetchStatusCounts(); };

    const openEditDrawer = (id) => {
        setEditInvoiceId(id);
        setDrawerClosing(false);
        setShowEditDrawer(true);
    };

    const closeEditDrawer = () => {
        if (!showEditDrawer) return;   // already closed
        setDrawerClosing(true);        // start exit animation
        // Wait for the CSS transition (matches .drawer-closing duration)
        setTimeout(() => {
            setShowEditDrawer(false);
            setEditInvoiceId(null);
            setDrawerClosing(false);
        }, 280);
    };

    useEffect(() => {
        if (showEditDrawer && !drawerClosing) {
            setDrawerMounted(false);
            const id = requestAnimationFrame(() => {
                // Second RAF is safest on slow browsers
                requestAnimationFrame(() => setDrawerMounted(true));
            });
            return () => cancelAnimationFrame(id);
        }
    }, [showEditDrawer, drawerClosing]);    

    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <SuperAdminSidebar />}
                {userType === "leader" && <LeaderSidebar />}
                {userType === "manager" && <ManagerSidebar />}
                {userType === "member" && <MemberSidebar />}
            </div>

            <div className="admin-content">
                <AdminNavbar pageTitle="Invoice" />

                <div className="all-content">

                    {/* ========== STATUS STATS BAR ========== */}
                    <div className="invoice-stats-bar">
                        <div className="stat-box unpaid"><div className="stat-amount">$ 0.00</div><div className="stat-label">Total Outstanding Invoice</div></div>
                        <div className="stat-box paid"><div className="stat-amount">$ 0.00</div><div className="stat-label">Total Invoice Amount</div></div>
                        <div className="stat-box partial"><div className="stat-amount">$ 0.00</div><div className="stat-label">Partially Paid Invoice</div></div>
                        <div className="stat-box overdue"><div className="stat-amount">$ 0.00</div><div className="stat-label">Past Due Invoice</div></div>
                        <div className="stat-box draft"><div className="stat-amount">$ 0.00</div><div className="stat-label">Paid Invoice</div></div>
                    </div>
                    {/* ==================================== */}

                    <div className="invoice-main-section">
                        <div className="invoice-tabs-container">
                            <button className={`invoice-tab-btn ${activeTab === 'All Invoices' ? 'active-tab' : ''}`} onClick={() => setActiveTab('All Invoices')}>All Invoices</button>
                            <button className={`invoice-tab-btn ${activeTab === 'Create Invoice' ? 'active-tab' : ''}`} onClick={() => setActiveTab('Create Invoice')}>Create Invoice</button>
                        </div>
                        <div className="invoice-content-area">
                            {activeTab === 'All Invoices' && <AllInvoice openEditDrawer={openEditDrawer} refreshTrigger={activeTab} />}
                            {activeTab === 'Create Invoice' && <NewInvoiceForm onInvoiceCreated={handleInvoiceCreated} currentUserFullName={userFullName} />}
                        </div>
                    </div>

                </div>
            </div>

{/* ========== EDIT SIDE DRAWER ========== */}
{showEditDrawer && (
    <>
        <div
            className={`invoice-drawer ${
                drawerClosing ? 'drawer-closing' : (drawerMounted ? 'drawer-open' : '')
            }`}
            style={{
                position: 'fixed', top: 0, right: 0, width: '520px', height: '100vh',
                background: '#eee6e6', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 9999,
                overflowY: 'auto', padding: '20px',
                border: '1px solid #b8b6b699',
            }}
        >
            <div className="invoice-drawer-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h3 style={{ margin: 0 }}>Edit Invoice</h3>
                <button onClick={closeEditDrawer} className="invoice-drawer-close">×</button>
            </div>
            <EditInvoiceForm
                invoiceId={editInvoiceId}
                onInvoiceUpdated={() => { closeEditDrawer(); setActiveTab('All Invoices'); fetchStatusCounts(); }}
                currentUserFullName={userFullName}
                onCancel={closeEditDrawer}
            />
        </div>
        <div
            className={`invoice-drawer-overlay ${
                drawerClosing ? 'overlay-closing' : (drawerMounted ? 'overlay-open' : '')
            }`}
            onClick={closeEditDrawer}
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 9998 }}
        />
    </>
)}
            {showEditDrawer && <div className="invoice-drawer-overlay" onClick={closeEditDrawer} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 9998 }} />}
        </div>
    )
}

export default Invoice;